import { Fragment } from 'react';

export function forbiddenChatRanges(content: string, spans?: string): number[][] {
  try {
    const parsed = JSON.parse(spans || '[]');
    if (Array.isArray(parsed) && parsed.every(range => Array.isArray(range) && range.length === 2 &&
      range.every(Number.isSafeInteger) && range[0] >= 0 && range[1] > range[0] && range[1] <= content.length)) return parsed;
  } catch { /* Legacy messages have no word positions. */ }
  return [];
}

export default function ChatModeratedText({ content, spans, strikeWholeMessage = false, renderText = value => value }: {
  content: string; spans?: string; strikeWholeMessage?: boolean; renderText?: (text: string) => React.ReactNode;
}) {
  if (strikeWholeMessage) return <s data-chat-forbidden-message style={{ color: 'inherit' }}>{renderText(content)}</s>;
  const ranges = forbiddenChatRanges(content, spans);
  const parts: React.ReactNode[] = [];
  let offset = 0;
  for (const [start, end] of ranges) {
    if (start < offset) continue;
    parts.push(<Fragment key={`text-${offset}`}>{renderText(content.slice(offset, start))}</Fragment>);
    parts.push(<s key={`word-${start}`} data-chat-forbidden-word style={{ color: 'inherit' }}>{renderText(content.slice(start, end))}</s>);
    offset = end;
  }
  parts.push(<Fragment key={`text-${offset}`}>{renderText(content.slice(offset))}</Fragment>);
  return <>{parts}</>;
}
